import type { FilterableIndicator } from "components/screener/v2/ScreenerFilterableIndicators";

export function genFilterButtonId(indicator: FilterableIndicator) {
  return `fb/${indicator.objectId}`;
}
export function openFilterPopover(indicator: FilterableIndicator) {
  if (typeof document !== "undefined") {
    const isProbablyMobile = "ontouchstart" in document.documentElement && window.innerWidth < 1024;
    if (isProbablyMobile) {
      return;
    }
    const button = document.getElementById(genFilterButtonId(indicator));
    if (button) {
      button.click();
    }
  }
}
